import React, { FC, Fragment } from 'react';
import { Box } from '@wix/design-system';
import {
  GlobalDesignGroupAction,
  GlobalDesignStyleGroup,
  StylesDerivedNativeActionNames,
} from './types';
import { ComponentsPlatformService } from '@wix/editor-platform-manifest-services';

type StyleLobbyListProps = {
  actionName: StylesDerivedNativeActionNames;
  items: GlobalDesignStyleGroup[];
  action: GlobalDesignGroupAction;
  onItemSelect: (item: GlobalDesignStyleGroup) => void;
  componentsAPI: ComponentsPlatformService;
};

const StyleLobbyList: FC<StyleLobbyListProps> = ({
  actionName,
  items,
  action,
  onItemSelect,
  componentsAPI,
}) => {
  return (
    <Box direction="vertical" gap="2" paddingTop="4">
      {items.map((item, i) => (
        <Fragment key={i}>
          {React.createElement(action.lobbyItem, {
            actionName,
            group: item,
            onSelect: () => onItemSelect(item),
            componentsAPI,
          })}
        </Fragment>
      ))}
    </Box>
  );
};

export default StyleLobbyList;
